module.exports = __webpack_public_path__ + "static/img/caseDetails_head_01_zh.169adde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/caseDetails_head_01_zh.png
// module id = TdUz
// module chunks = 34